import chronolog, {
	ErrPayload,
	LogOptions,
	SetupOptions,
} from '@farmart-engineering/chronolog';
import metaData from '../../package.json';
import environment from '@/config/environment';
import { useEffect } from 'react';
import {
	createRoutesFromChildren,
	matchRoutes,
	useLocation,
	useNavigationType,
} from 'react-router-dom';

export const logger = {
	...chronolog,
	defaultAttr: {},
	initialize: function () {
		const loggerENV =
			environment.ENVIRONMENT === 'stage'
				? 'staging'
				: (environment.ENVIRONMENT as SetupOptions['environment']);
		const options: SetupOptions = {
			index: ['fmt-os', 'fe', loggerENV].join('-'),
			deviceType: 'web',
			production: environment.ENVIRONMENT === 'production',
			autoOpenSearch: !['local', 'development'].includes(environment.ENVIRONMENT),
			console: environment.ENVIRONMENT !== 'production',
			environment: loggerENV,
			version: metaData.version,
		};

		if (false === import.meta.env.DEV) {
			options.sentry = {
				dsn: environment.SENTRY_DSN,
				environment: loggerENV,
				tracesSampleRate: 0.01,
				replaysSessionSampleRate: 0.01,
				replaysOnErrorSampleRate: 0.01,
				reactRouter: {
					useEffect: useEffect,
					useLocation: useLocation,
					useNavigationType: useNavigationType,
					createRoutesFromChildren: createRoutesFromChildren,
					matchRoutes: matchRoutes,
				},
			};
		}

		const result = chronolog.initialize(options);

		if (true === options.console) {
			logger.info(
				`🎯 Logger ready! [${options.index}] (${options.environment}) v${options.version}`,
			);
		}

		return result;
	},
	info: function (
		message: string,
		metaInfo?: Record<string, any>,
		options?: LogOptions,
	) {
		const meta = {
			...logger.defaultAttr,
			...metaInfo,
		};
		return chronolog.log(message, {
			meta: meta,
			...options,
		});
	},
	err: function (
		message: Error | string,
		payload?: Record<string, any>,
		options?: ErrPayload,
	) {
		const isErrorInstance = message instanceof Error;
		const jsonPayload = {
			...payload,
			...logger.defaultAttr,
		};
		return chronolog.error(isErrorInstance ? message : new Error(message), {
			jsonPayload,
			...options,
		});
	},

	setDefaultAttributes(attrs: Record<string, string | number | boolean>) {
		logger.defaultAttr = {
			...logger.defaultAttr,
			...attrs,
		};
	},
};
